import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IGeographyNode } from '../../shared/interfaces/geography-node.interface';
import { SEARCH_OPTION_INPUT } from '../../shared/constants/search-bar-input.constants';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IProductNode } from '../../shared/interfaces/product-node.interface';
import { IFavouriteGeographyNode } from '../../shared/models/favourite-geography-node.model';

@Component({
  selector: 'claims-search-bar',
  imports: [CommonModule, NgSelectComponent, FormsModule],
  standalone: true,
  templateUrl: './search-bar.html',
  styleUrl: './search-bar.scss',
})
export class SearchBarComponent {
  @Input() public searchOptionsList: Array<IGeographyNode> = [];
  @Input() public enableDropdownStyling = false;
  @Input() public hideSelectedItems = false;
  @Output() public selectedSearchOptionEvent = new EventEmitter();
  @Output() public closeSearchEvent = new EventEmitter();
  public searchOptions: Array<IGeographyNode | IProductNode> = [];
  public openSearch = false;
  public filteredOptions: Array<IGeographyNode | IProductNode> = [];
  public selectedValues: Array<any> = [];
  public dropdownCloseFlag = false;

  @ViewChild(NgSelectComponent) public readonly ngSelectComponent!: NgSelectComponent;

  public ngOnChanges(changes: SimpleChanges): void {
    this.searchOptions = [];
    this.getSearchOptionFlatList(changes['searchOptionsList'].currentValue);
  }

  public search(searchText: string): void {
    if (searchText === null) {
      return;
    }
    if (searchText.length >= SEARCH_OPTION_INPUT.searchTextMinLength) {
      this.filteredOptions = this.searchOptions.filter(
        (node: IGeographyNode | IProductNode) => {
          const matchesSearch = node.name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
          const shouldHideSelected = this.enableDropdownStyling || this.hideSelectedItems;
          const shouldShow = shouldHideSelected ? matchesSearch && !node.isSelected : matchesSearch;
          return shouldShow;
        }
      );
      this.openSearch = true;
    } else {
      this.filteredOptions = [];
      this.openSearch = false;
    }
  }

  public onFilterSelection(selectedOption: IGeographyNode | IProductNode | IFavouriteGeographyNode): void {
    this.selectedValues = [];    
    this.openSearch = false;

    const asFavourite = selectedOption as IFavouriteGeographyNode;
    if (asFavourite?.isFavourite) {
        this.searchOptions.forEach(node => {
            const asFavNode = node as unknown as IFavouriteGeographyNode;
            if (asFavNode.isFavourite && asFavNode.code === asFavourite.code) {
                node.isSelected = true;
            }
        });
    }

    if (this.ngSelectComponent) {
      this.ngSelectComponent.handleClearClick();
    }
    
    setTimeout(() => {
      const searchInput = document.querySelector('.e-selector-search-drop input') as HTMLInputElement;
      if (searchInput) {
        searchInput.value = '';
      }
      this.filteredOptions = [];
    }, 0);
    
    this.selectedSearchOptionEvent.emit(selectedOption);
  }

  public onClear(): void {
    this.openSearch = false;
    this.filteredOptions = [];
  }

  public focusSearchInput(): void {
    if (this.ngSelectComponent) {
      setTimeout(() => {
        const searchInput = document.querySelector('.e-selector-search-drop input') as HTMLInputElement;
        if (searchInput) {
          searchInput.value = '';
        }
        this.filteredOptions = [];
        this.openSearch = false;
      }, 0);
      this.ngSelectComponent.focus();
    }
  }

  private getSearchOptionFlatList(searchOptionList: Array<IGeographyNode | IProductNode>): void {
    searchOptionList.forEach((option: IGeographyNode | IProductNode) => {
      this.searchOptions.push(option);
      const asFavourite = option as unknown as IFavouriteGeographyNode;
      if (!asFavourite?.isFavourite && option.children) {
        this.getSearchOptionFlatList(option.children);
      }
    });
  }
}
